import { SubscriptionProduct } from './Subscription';

export type SignupState = {
  email: string;
  phone: string;
  password: string;
  referralCode: string;
  optinPromotion: boolean;
  optinText: boolean;
  firstName: string;
  lastName: string;
  birthday: string;
  instagram: string;
  tiktok: string;
  otherSocial?: string;
  ambassadorPitch?: string;
  address: string;
  aptUnitSuite: string;
  city: string;
  state: string;
  postalCode: string;
  creditCardLast4: string;
  expirationDate: string;
  stripePaymentMethodTokenId: string;
  stripePaymentMethodBrand: string;
  sameAsShippingAddress: boolean;
  billingAddress: string;
  billingAptUnitSuite: string;
  billingCity: string;
  billingState: string;
  billingPostalCode: string;

  /**
   * Stripe SetupIntent id, set once `confirmSetup` succeeds on the single-page
   * application. The Stripe customer and payment method already exist
   * server-side at that point, which is why the submit path skips
   * `attachPaymentMethodToNewCustomer` when this is present.
   */
  paymentSetupIntentId?: string;

  /** Subscription data */
  subscription_level: string;
  insurance_level: string;
  addon_subscription: string;
  plan?: SubscriptionProduct;
  paymentAgreement: boolean;
  terms: boolean;

  internal_notes?: string;
  brand_ambassador?: boolean;
  utm_source?: string;
  fbc?: string;
  fbp?: string;
  gclid?: string;
};

export type SignupContextValue = SignupState;

export type SignupBrokerActions = {
  updateFormValues: (formValues: Partial<SignupState>) => void;
  resetForm: () => void;
  formIsComplete: () => boolean;
};

export type SignupBrokeredValue = {
  value: SignupContextValue;
  actions: SignupBrokerActions;
};

export const INITIAL_SIGNUP_VALUE: SignupState = {
  email: '',
  phone: '',
  password: '',
  referralCode: '',
  optinPromotion: true,
  optinText: false,
  firstName: '',
  lastName: '',
  birthday: '',
  instagram: '',
  tiktok: '',
  address: '',
  aptUnitSuite: '',
  city: '',
  state: '',
  postalCode: '',
  creditCardLast4: '',
  expirationDate: '',
  stripePaymentMethodTokenId: '',
  stripePaymentMethodBrand: '',
  sameAsShippingAddress: true,
  billingAddress: '',
  billingAptUnitSuite: '',
  billingCity: '',
  billingState: '',
  billingPostalCode: '',
  addon_subscription: 'none',
  insurance_level: 'standard',
  subscription_level: '',
  paymentAgreement: false,
  terms: false,
  paymentSetupIntentId: '',
  utm_source: ''
};
